import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getAllTaskLogList, getUserLogByID, projectByUserId } from './finalReports.services'

// Initial state definition
const initialState = {
    taskLogs: [],
    totalLog: null,
    isLoading: false,
    error: null,
    userTaskLogs: [],
    userReportsTaskLogLoading: false,
    userProject: [],
    userProjectLoading: false,
    tableData: {
        page: 1,
        limit: 10,
        totalCount: 0,
        isNext: false,
        start: new Date().setHours(0, 0, 0, 0),
        end: new Date().setHours(23, 59, 59, 999),
        userId: [],
        projectId: [],
        dateType: 'day',
    },

    reportDrawerFilterData: {
        start: new Date().setHours(0, 0, 0, 0),
        end: new Date().setHours(23, 59, 59, 999),
        userId: [],
        projectId: [],
        dateType: 'day',
    },

    filters: {
        start: null,
        end: null,
    },
}

// Async thunk to fetch candidates
export const getAllUserReportList = createAsyncThunk(
    'finalReportsSlice/list',
    async (data) => {
        const response = await getAllTaskLogList(data)
        return response?.data
    }
)
export const getUserByIdAllTaskLog = createAsyncThunk(
    'finalReportsSlice/userTaskList',
    async (data) => {
        const response = await getUserLogByID(data)
        return response?.data
    }
)

export const getProjectByUserId = createAsyncThunk(
    'finalReportsSlice/userProject',
    async (userId) => {
        const response = await projectByUserId({ userId })
        return response?.data
    }
)

// Slice definition
export const finalReportsSlice = createSlice({
    name: 'finalReportsSlice',
    initialState,
    reducers: {
        setTableData: (state, action) => {
            state.tableData = action.payload
        },
        resetTableData: (state, action) => {
            state.tableData = {
                page: 1,
                limit: 10,
                totalCount: 0,
                isNext: false,
                start: new Date().setHours(0, 0, 0, 0),
                end: new Date().setHours(23, 59, 59, 999),
                userId: [],
                projectId: [],
                dateType: 'day',
            }
        },
        setDrawerFilter: (state, action) => {
            state.reportDrawerFilterData = action.payload
        },
        resetDrawerFilter: (state) => {
            state.reportDrawerFilterData = {
                start: state.tableData.start,
                end: state.tableData.end,
                userId: [],
                projectId: [],
                dateType: state.tableData.dateType,
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllUserReportList.pending, (state) => {
                state.isLoading = true
            })

            .addCase(getAllUserReportList.fulfilled, (state, action) => {
                state.taskLogs = action.payload.data
                state.totalLog = action.payload.totalLog
                state.isLoading = false
                state.error = null
                state.tableData.totalCount = action.payload.totalCount
                state.tableData.isNext = action.payload.isNext
            })
            .addCase(getAllUserReportList.rejected, (state, action) => {
                state.taskLogs = []
                state.isLoading = false
                state.error = action.payload.error
            })
            .addCase(getUserByIdAllTaskLog.pending, (state) => {
                state.userReportsTaskLogLoading = true
            })

            .addCase(getUserByIdAllTaskLog.fulfilled, (state, action) => {
                state.userTaskLogs = action.payload.data
                state.userReportsTaskLogLoading = false
                state.error = null

            })
            .addCase(getUserByIdAllTaskLog.rejected, (state, action) => {
                state.userTaskLogs = []
                state.isLoading = false
                state.error = action.payload.error
            })
            .addCase(getProjectByUserId.pending, (state) => {
                state.userProjectLoading = true
            })

            .addCase(getProjectByUserId.fulfilled, (state, action) => {
                state.userProject = action.payload.data
                state.userProjectLoading = false
                state.error = null

            })
            .addCase(getProjectByUserId.rejected, (state, action) => {
                state.userProject = []
                state.userProjectLoading = false
                state.error = action.payload.error
            })
    },
})

export default finalReportsSlice.reducer

// Export actions (if any)
export const { setTableData, setDrawerFilter, resetDrawerFilter, userProject, resetTableData } = finalReportsSlice.actions
